import "./SearchPage.scss";

import SearchPage from "./SearchPage";

export default SearchPage;
